export default "__VITE_ASSET__CbHVJfxK__"